import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

export default function CaixaRepasseAlert() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    api.get("/finance/caixa").then((r) => setCount(r.data?.pending_count || 0)).catch(() => {});
  }, []);
  if (!count) return null;
  return (
    <Link
      to="/financeiro/caixa"
      className="flex items-center gap-3 bg-amber-50 border-2 border-amber-300 rounded-2xl p-3.5 card-shadow hover:bg-amber-100 transition-colors"
      data-testid="caixa-repasse-alert"
    >
      <div className="w-9 h-9 rounded-full bg-amber-500 text-white flex items-center justify-center shrink-0">
        <Clock className="w-5 h-5" />
      </div>
      <p className="flex-1 font-heading text-sm md:text-base font-black text-amber-900">Temos repasses para ser dado baixa</p>
      <ChevronRight className="w-5 h-5 text-amber-700 shrink-0" />
    </Link>
  );
}
